import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5db8cdb8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "xag-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bannner" }, "免费领取P150高性能桨", -1))
const _hoisted_3 = { class: "device-box" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "device-box-title" }, "可参与活动的设备：", -1))
const _hoisted_5 = {
  key: 0,
  class: "device-box-empty"
}
const _hoisted_6 = { class: "device-list-content" }
const _hoisted_7 = { class: "device-list-name" }
const _hoisted_8 = { class: "device-list-sn" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desc" }, [
  /*#__PURE__*/_createTextVNode(" 活动规则： "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 1. 通过极飞官方渠道购买极飞 P150 套装，铭牌生产日期在2024年6月8日前且出厂配置标准桨的用户可免费领取P150高性能桨一套；"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 2. 领取时间：即日起至2024年9月30日，符合活动要求的 P150 用户凭飞机编码到购机门店处免费领取；"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 3. 用户购买P150套装时已标配“高性能桨”的，不再额外赠送；"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 4. 2024年9月30日前，符合活动范围内的用户未顺利领取到高性能桨，可联系极小美/400-780-3131 进行反馈；"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 5. 符合领取资格的用户，若未在活动有效时间内进行领取，则视为放弃该活动权益。 ")
], -1))
const _hoisted_11 = { class: "action-wrap" }

import { ref, withDefaults } from 'vue'
import AppHeader from '@/components/Header.vue'
import PopupCommonWrap from '@/components/popup/common-wrap.vue'
import type { IP150PaddleItem } from '@/types/activity'


export default /*#__PURE__*/_defineComponent({
  __name: 'list',
  props: {
    list: { default: () => [] }
  },
  emits: ['action'],
  setup(__props: any, { emit: emits }) {

const props = __props as { list: IP150PaddleItem[] };

const showPopup = ref(false)

const curItem = ref<IP150PaddleItem>()



const onClick = (item: IP150PaddleItem) => {
  if (!item.is_receiving) {
    showPopup.value = true
    curItem.value = item
  }
}



const onAction = (action: string) => {
  showPopup.value = false
  setTimeout(() => {
    emits('action', {
      action,
      item: curItem.value,
    })
  }, 500)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, { title: "免费领取P150高性能桨" }),
    _createElementVNode("section", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        (__props.list.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, "暂无可参与活动的设备"))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.list, (device) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "device-list-item",
            key: device.serial_number
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(device.name), 1),
              _createElementVNode("div", _hoisted_8, "SN:" + _toDisplayString(device.serial_number), 1)
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["device-list-btn", { disabled: device.is_receiving }]),
              onClick: ($event: any) => (onClick(device))
            }, _toDisplayString(device.is_receiving ? '已领取' : '免费领取'), 11, _hoisted_9)
          ]))
        }), 128))
      ]),
      _hoisted_10
    ]),
    _createVNode(PopupCommonWrap, {
      title: "录入设备信息",
      show: showPopup.value,
      "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => ((showPopup).value = $event)),
      teleport: "body",
      headerStyle: { textAlign: 'center' }
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", {
            class: "action-item",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (onAction('scan')))
          }, "扫描包装二维码"),
          _createElementVNode("div", {
            class: "action-item",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (onAction('input')))
          }, "输入包装序列号")
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}
}

})